import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMESTAMP_MULTIPLY, TIMEOUT_STORE} from 'util/constants';

const
    name = 'spendingByProductArea',
    exports = storeModuleFactory({
        name,
        endpoint:           endpoints.spendingByConcept.endpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
        transformResultsFn: json => [json],
        parseParameters:    parameters => ({
            start_date: Math.floor(parameters.startDate / TIMESTAMP_MULTIPLY),
            end_date:   Math.floor(parameters.endDate / TIMESTAMP_MULTIPLY)
        }),
        defaultParameters: {
            by: 'product_area'
        }
    });


module.exports = exports;

// /api/v2/reporting/spending?by=vendor&type=daily



// WEBPACK FOOTER //
// ./src/modules/store/spendingByProductArea.js